<template>
  <div class="search-tab">
    <div class="first-menu">
      <div
        class="menu-item"
        :class="{cur: curTabKey === item.key}"
        v-for="item in firstMenuList"
        :key="item && item.key"
        v-track="{functionName: item.functionName}"
        @click="switchIdFirst(item)"
      >
        <img v-if="curTabKey === item.key" class="menu-icon" :src="item && item.activeIcon" alt="">
        <span class="name">{{ item && item.name }}</span>
      </div>
    </div>
    <div class="second-menu" :style="{
      gridTemplateColumns: curTabKey === '1' ? 'repeat(4, 1fr)':'repeat(3, 1fr)'
    }">
      <div
        class="menu-item"
        :class="{cur: curTabType === item.type}"
        v-for="item in visibleSecondMenuList"
        :key="item && item.type"
        v-track="{functionName: item.functionName}"
        @click="switchIdSecond(item)"
      >
        <span class="name">{{ item && item.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['curTabKey', 'curTabType'],
  data() {
    return {
      firstMenuList: [
        {
          functionName: '搜索-普通搜索',
          name: '普通搜索',
          activeIcon: require('../../../assets/images/home/img16.png'),
          key: '1',
        },
        {
          functionName: '搜索-智能搜索',
          name: '智能搜索',
          key: '2',
          activeIcon: require('../../../assets/images/home/img3.png'),
        },
      ],
      // 类型与库里一致：1文献解读 2课程 3病例 4帖子 5视频 6PPT 7文献 8图文
      // 智能搜索只召回文献解读、课程、病例
      secondMenuList: [
        {functionName: '搜索-课程', type: '2', name: '课程', ai: true},
        {functionName: '搜索-病例', type: '3', name: '病例', ai: true},
        {functionName: '搜索-文献解读', type: '1', name: '文献解读', ai: true},
        {functionName: '搜索-文献', type: '7', name: '文献'},
        {functionName: '搜索-视频', type: '5', name: '视频'},
        {functionName: '搜索-PPT', type: '6', name: 'PPT'},
        {functionName: '搜索-图文', type: '8', name: '图文'},
        {functionName: '搜索-帖子', type: '4', name: '帖子'},
      ]
    }
  },
  computed: {
    visibleSecondMenuList() {
      if (this.curTabKey === '2') {
        return this.secondMenuList.filter(item => item.ai)
      }
      return this.secondMenuList
    }
  },
  methods: {
    switchIdFirst(item) {
      this.$emit('update:curTabKey', item.key)
      this.$emit('update:curTabType', '2')
      this.$emit('switch', 'first')
    },
    switchIdSecond(item) {
      this.$emit('update:curTabType', item.type)
      this.$emit('switch', 'second')
    }
  }
}
</script>

<style scoped lang="less">
.search-tab {
  display: flex;
  flex-direction: column;
}
.first-menu {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 10px;
  box-sizing: border-box;
  height: 30px;
  padding: 0 50px;

  .menu-item {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .name {
      font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
      font-size: 14px;
      color: #564C47;
      font-weight: bold;
    }

    .menu-icon {
      width: 20px;
      margin-right: 5px;
    }

    &.cur {
      .name {
        color: #EB1700;
      }
    }
  }
}
.second-menu {
  width: 100%;
  display: grid;
  column-gap: 10px;
  row-gap: 10px;
  box-sizing: border-box;
  margin-top: 10px;
  padding: 0 35px;
  .menu-item {
    width: 100%;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #F2F0EE;
    border-radius: 35px;
    cursor: pointer;
    .name {
      font-family: PingFang HK, PingFang HK;
      font-weight: 400;
      font-size: 14px;
      color: #564C47;
      white-space: nowrap;
    }
    &.cur {
      background: rgba(235,23,0,0.05);
      .name {
        color: #EB1700;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/pageSearch/SearchTab.vue